var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "url(#pattern0_464_407)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_464_407",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_464_407",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_464_407",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACh0lEQVR4nO2dv4rVQBTGY6EP46oI25g5KUQ78QF8BztFbAS3UwQFC5Fl830T8U+x1na2lvoGgqxuoWtjqS5cyXUFWeJq9iZnvJnvB1Pm3jM/zk3OTOZwi0IIIYQQQgghxP9LiPG0kY+N3DbymwEfAtCUdX0idWyTwYCrAdg1crZ/BPK7AZdTx7j0GLDWJbhj3Egdaw6SZ5LtJ1myHSVLtqNkyXaULNmOkn8OlX4+oud1dtOs7Pu6vLGxspqMqeeWhewAbKWeVx6yga+p55SL7Pep55OF7EA+KrITB6z1vmax+/NutbFxqsgF+12Yo+xAXilywTpEBeB2n8+oyOuHkHyzyAU7IBvHlC3JHF+2JHP8zJZkji9bkjm+bElmz5LsMKVfz2uWGhtwydw3s7PBxtlxk2ynPWTJ9pAs2Y6Ss5dtjpKzlW0JJM9Fa4OIkqxMXjJMtwtJngSmTJbkSWDKZEmeBKZMluRJoEx2QJIdkGQHJNkBSXZAkh2QZAck2QFJdmB1ff1o1TSrZYznQ11faxtnXN7zIaNjWl2Eui4l2SnD5227yuTxMeCzjgQ4EMi3OnfhQABe68HnQABe6gSRA0Y+1zEtBwy4qzrZgZI8p8XIgpwhT/7LqsxiPGvknQA8NeCFAa+MfDOvSA4q/3Jf8f0ikLeGEGJNs2LAF0nuYjY7YuS7obLPyHvK5C4xQDXkT72M8ZJuF90Z+HDItoSy3fHL6aR9j82inSEfYsc3N4+NE+0SUwEX1XDjQCCfqbvJgUB+UiuZA3t/MvC3Xr0tI++3r7Y8YpokbWXxh/68nQA8qGK0ts5OHefS01YIe7K3Dfho5JNAXmirkdSxCSGEEEIIIYQoFuMHDcafxhHInSIAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.35468fd1ff55eff290d1694d7b866f91.svg";
export { ForwardRef as ReactComponent };